import format from 'date-fns/format';
import ExportService from './ExportService';
import { currentPatientSelector } from '../patient';
import { sessionUserSelector } from '../session';

const toRequest = ({ primaryCaregiver, patient, ...rest }) => ({
  ...rest,
  primaryCareGiver: {
    ...primaryCaregiver,
    include: primaryCaregiver.isIncluded,
  },
  patient: {
    ...patient,
    include: patient.isIncluded,
  },
});

// THUNKS
export const fetchPdfExportAsync = pdfFields => (dispatch, getState) => {
  const state = getState();
  const user = sessionUserSelector(state);
  const patient = currentPatientSelector(state);
  const pdfDate = format(new Date(), 'YYYY.MM.DD.HHmm');
  const fileName = `${patient.lastName}-care-plan-${pdfDate}.pdf`;

  return dispatch(
    ExportService.getPdf(user.id, fileName, toRequest(pdfFields)),
  );
};

export const fetchTermsAsync = () => (dispatch, getState) => {
  return dispatch(ExportService.getTerms());
};



// WEBPACK FOOTER //
// ./src/lib/dataLayer/export/thunks.js